import React, { Component } from 'react';

import TopLevelLayout from '../components/Layout/TopLevelLayout';
import SEO from '../components/SEO/SEO';
import MainHeader from '../components/Layout/Header';
import MainFooter from '../components/Layout/Footer';
import CounselorLeadSignUp from '../components/Leads/CounselorLeadSignUp';
import Page from '../components/Layout/Page.div';
import trackPageView from '../components/analytics/trackPageView';
import * as CONTENT_GROUPS from '../components/analytics/contentGroups';

class CreditCounselorPage extends Component {
  componentDidMount() {
    trackPageView({
      contentGroup: CONTENT_GROUPS.LANDING_PAGE,
    });
  }

  render() {
    return (
      <TopLevelLayout showPersistentCta={false}>
        <div className="index-container">
          <SEO
            title="Talk to a Free Counselor to discuss alternatives to bankruptcy"
            description="Trained staff provide free counseling to people who want to discuss alternatives to bankruptcy."
          />
          <MainHeader />
          <Page padding="0">
            <CounselorLeadSignUp />
          </Page>
          <MainFooter showAttorneyLink={false} />
        </div>
      </TopLevelLayout>
    );
  }
}

export default CreditCounselorPage;
